<template>
  <div class="py-2 px-6 select-none" v-if="show">
    <button @click="save"
      class="flex w-full justify-center rounded-md bg-secondary px-3 h-10 py-2 font-medium leading-6 text-white shadow-sm hover:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary"
      :class="{ 'opacity-50 pointer-events-none': saveLoading, 'opacity-50 pointer-events-none': !canSave }"
      :disabled="saveLoading || !canSave">
      <template v-if="saveLoading">
        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
          </path>
        </svg>
      </template>
      <template v-else>
        Gem indberetning
      </template>
    </button>
  </div>
</template>

<script lang='ts'>
import { DietReport, ReportType, SicknessReport, TimeReport, TransportReport } from '@/models/report.model'
import { computed, defineComponent, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'SaveReportButton',
  setup () {
    const store = useStore()
    const router = useRouter()
    const saveLoading = ref(false)
    const canSave = ref(false)
    const show = ref(false)
    const currentReport = computed(() => store.getters['report/currentReport'])
    const currentType = computed(() => store.getters['report/reportType'])

    watch([currentReport, currentType], ([newReport, type]) => {
      switch (type) {
        case ReportType.TIME: {
          const report = newReport as TimeReport
          canSave.value = validateTimeReport(report)
          show.value = report && report.state !== 'FREE'
          break
        }
        case ReportType.SICK: {
          const report = newReport as SicknessReport
          canSave.value = validateSicknessReport(report)
          show.value = report && report.state !== 'FREE'
          break
        }
        case ReportType.TRANSPORT: {
          const report = newReport as TransportReport
          canSave.value = validateTransportReport(report)
          show.value = report && report.state !== 'FREE'
          break
        }
        case ReportType.DIET: {
          const report = newReport as DietReport
          canSave.value = validateDietReport(report)
          show.value = report && report.state !== 'FREE'
          break
        }
      }
    }, { deep: true, immediate: true })

    const save = async () => {
      if (saveLoading.value) return
      saveLoading.value = true

      try {
        const response = await store.dispatch('report/saveReport')
        if (response?.success) {
          switch (response.type) {
            case ReportType.TIME:
              router.push('/reports/week/time')
              break
            case ReportType.TRANSPORT:
              router.push('/reports/week/transport')
              break
            case ReportType.SICK:
              router.push('/reports/week/sick')
              break
            case ReportType.DIET:
              router.push('/reports')
              break
          }
        } else {
          console.log('SAVE REPORT FAILED RESPONSE', response)
        }
      } finally {
        saveLoading.value = false
      }
    }

    function validateTimeReport (report: TimeReport): boolean {
      return report.timeFrom !== undefined && report.timeTo !== undefined && report.timeSpent !== undefined
    }
    function validateSicknessReport (report: SicknessReport): boolean {
      return report.timeFrom !== undefined && report.timeTo !== undefined && report.timeSpent !== undefined
    }
    function validateTransportReport (report: TransportReport): boolean {
      return report.timeFrom !== undefined && report.timeTo !== undefined && report.timeSpent !== undefined && report.transportType !== undefined && report.kmUsed !== undefined
    }
    function validateDietReport (report: DietReport): boolean {
      return report.amountConnectingHours !== undefined && report.daysAmountBoarding !== undefined && report.daysAmountLodging !== undefined
    }

    return { save, saveLoading, canSave, show }
  }
})
</script>
